import React from 'react'
import './admProfile.css'

import Sidebar from '../../components/sidebar/Sidebar'
import Navbar from '../../components/navbar/Navbar'
export default function admProfile() {
  return (
      <>
      
          <div className="home">
              <Sidebar />
              <div className="homeContainer">
                  <Navbar />
                  <div className='featured'>
                  <div class="page-content page-container" id="page-content">
                      <div class="padding">
                          <div class="row container d-flex justify-content-center">
                              <div class="col-xl-12 col-md-12">
                                  <div class="card user-card-full">
                                      <div class="row m-l-0 m-r-0">
                                          <div class="col-sm-4 bg-c-lite-green user-profile">
                                              <div class="card-block text-center text-white">
                                                  <div class="m-b-25">
                                                          <img src="https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=100" class="img-radius" alt="User"/>
                                                  </div>
                                                  <h6 class="f-w-600">Purav</h6>
                                                  <p>Web Designer</p>
                                                  <i class=" mdi mdi-square-edit-outline feather icon-edit m-t-10 f-16"></i>
                                              </div>
                                          </div>
                                          <div class="col-sm-8">
                                              <div class="card-block">
                                                  <h6 class="m-b-20 p-b-5 b-b-default f-w-600">Information</h6>
                                                  <div class="row">
                                                      <div class="col-sm-6">
                                                          <p class="m-b-10 f-w-600">Email</p>
                                                          <h6 class="text-muted f-w-400">3ppp1m@gmail.com</h6>
                                                      </div>
                                                      <div class="col-sm-6">
                                                          <p class="m-b-10 f-w-600">Phone</p>
                                                          <h6 class="text-muted f-w-400">+91-9671810274</h6>
                                                      </div>
                                                  </div>
                                                  <h6 class="m-b-20 m-t-40 p-b-5 b-b-default f-w-600">Projects</h6>
                                                  <div class="row">
                                                      <div class="col-sm-6">
                                                          <p class="m-b-10 f-w-600">Login Email</p>
                                                          <h6 class="text-muted f-w-400">Admin@gmail.com</h6>
                                                      </div>
                                                      <div class="col-sm-6">
                                                          <p class="m-b-10 f-w-600">Password</p>
                                                          <h6 class="text-muted f-w-400">Purav@2000</h6>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      </div>
                  </div>
              </div>
          </div>
      
      </>
  )
}
